module.exports = __webpack_public_path__ + "static/img/contact_spimg.6052a98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact_spimg.jpg
// module id = nVj5
// module chunks = 1